/*
* Configuration for Components
*/
export default function () {
  return {
    uploaderPanel: {
      buttonClasses: 'primary-color base'
    }
  }
}
